<div class="loader" [hidden]="!loading">
    <div class="loader-inner">
        <img src="assets/images/logo.svg" alt="JHSF ID">
        <p>Aguarde...</p>
    </div>
</div>